import React from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { FeatureDemandBannerAC } from './AC/FeatureDemandBanner.AC';
import { FeatureDemandBannerOV } from './OV/FeatureDemandBanner.OV';
import { FeatureDemandBannerAP } from './AP/FeatureDemandBanner.AP';
import { FeatureDemandBannerDS } from './DS/FeatureDemandBanner.DS';
import { FeatureDemandBannerOV as FeatureDemandBannerOV_GB } from './OV/GB/FeatureDemandBanner.OV';
import { FeatureDemandBannerStyled } from './FeatureDemandBannerStyled';
import { SC } from 'src/styles/theme';

export type FeatureDemandBannerProps = SC & {
    image: string;
    label: string;
    title: string;
    isConfigPage?: boolean;
    isBasketPage?: boolean;
};

const FeatureDemandBanner = (props: FeatureDemandBannerProps) => {
    if (BRAND === 'AC') return <FeatureDemandBannerAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <FeatureDemandBannerOV_GB {...props} /> : <FeatureDemandBannerOV {...props} />;
    if (BRAND === 'AP') return <FeatureDemandBannerAP {...props} />;
    if (BRAND === 'DS') return <FeatureDemandBannerDS {...props} />;
    return <FeatureDemandBannerStyled {...props} />;
};

export default FeatureDemandBanner;
